import http from '@/core/http'
import { map } from 'lodash'

const url = 'entidades/parceiros'

const state = {
  itens: [],
  item: {
    id: '',
    cod: '',
    name: '',
    email: '',
    cnpj: '',
    address: '',
    cep: '',
    phone: '',
    city: '',
    state: '',
    neighborhood: '',
    number: '',
    complement: '',
    customerId: '',
  },
  lista: '',
  itemAddPermission: [],
  acl: null,
  itemSelect: [],
  totalItens: 0,
  cotacoes: [],
  itemCotacao: {
    modalityId: '',
  },
  listaModalidades: []
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, { params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    if (!result.data.id) throw result
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete(url, { params: payload })
    return Promise.resolve(result)
  },

  buscarItem: async ({ commit }, payload) => {
    const result = await http.get(`${url}view`, payload)
    commit('LISTA_ITEM', result.data)
  },

  getItem: ({ commit }, payload) => {
    commit('LISTA_ITEM', payload)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  obterItensSelect: async ({ commit }) => {
    const result = await http.get('/entidades/cliente')
    commit('LISTA_ITENS_SELECT', result.data.resultMap)
  },

  clearItens: ({ commit }) => {
    commit('CLEAR_ITENS')
    commit('LIMPAR_ITEM')
  },

  obterCotacoes: async ({ commit }, { entityId }) => {
    const result = await http.get(`/entidades/parceiros/cotacoes`, { params: { entityId } })
    commit('LISTA_COTACOES', result.data.data)
  },

  clearCotacoes: ({ commit }) => {
    commit('LIMPA_COTACOES')
  },

  clearItemCotacoes: ({ commit }) => {
    commit('LIMPAR_ITEM_COTACOES')
  },

  obterModalidades: async ({ commit }, { entityId }) => {
    const result = await http.get(`/entidades/parceiros/modalidades`, { params: { entityId } })
    commit('LISTA_MODALIDADES', result.data.data)
  },

  cadastrarCotacao: async (_, payload) => {
    const result = await http.post(`/entidades/parceiros/cotacoes`, payload)
    return Promise.resolve(result)
  },

  editarCotacao: async (_, payload) => {
    const result = await http.put(`/entidades/parceiros/cotacoes`, payload)
    return Promise.resolve(result)
  },

  deleteCotacao: async (_, { id }) => {
    const result = await http.delete(`/entidades/parceiros/cotacoes`, { params: { id } })
    return Promise.resolve(result)
  },

  setComissao: async ({ commit }, payload) => {
    commit('SET_COMISSAO', payload)
  }
}

const mutations = {
  'LISTA_ITENS'(state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM'(state, payload) {
    state.item = Object.assign({}, payload)
  },

  'LIMPAR_ITEM'(state) {
    state.item = {
      id: '',
      cod: '',
      name: '',
      cnpj: '',
      phone: '',
      cep: '',
      address: '',
      city: '',
      state: '',
      neighborhood: '',
      number: '',
      complement: '',
      responsible: {
        name: '',
        cpf: '',
        phone: '',
        phoneComercial: '',
        cep: '',
        address: '',
        state: '',
        city: '',
        neighborhood: '',
        number: '',
        complement: '',
      }
    }
  },
  'LIMPA_COTACOES'(state) {
    state.cotacoes = []
    state.itemCotacao = {}
  },
  'LIMPAR_ITEM_COTACOES'(state) {
    state.itemCotacao = {}
  },

  'LISTA_ITENS_SELECT'(state, payload) {
    state.itemSelect = payload
  },

  'CLEAR_ITENS'(state) {
    state.itens = []
    state.itensSelect = []
    state.totalItens = 0
  },

  'LISTA_COTACOES'(state, payload) {
    state.cotacoes = payload
  },

  'LISTA_MODALIDADES'(state, payload) {
    state.listaModalidades = payload
  },

  'SET_COMISSAO'(state, payload) {
    state.itemCotacao = payload
  }
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  item: state => state.item,
  listaItensSelect: (state) => {
    return map(state.itemSelect, item => {
      return {
        text: item.name,
        value: item.id
      }
    })
  },
  cotacoes: state => state.cotacoes,
  listaModalidades: state => state.listaModalidades,
  itemCotacao: state => state.itemCotacao
}

export default { namespaced: true, state, actions, mutations, getters }